<template>
  <div class="container p-x-2:mo p-y-2 p-y-4:t c-gray70 m-b-2 d-flex:t fd-row ai-center">
    <span class="h5 m-r-2:t text-bold d-block:mo" selenium="Header-Subtask-Label">
      {{ service.display_name }}
    </span>
    <transition name="fade">
      <span
          v-if="isCityChosen && isStateChosen"
          class="h6 m-r-2:t d-block:mo"
          selenium="Header-Location-Label">
        Near {{ location.city }}, {{ location.state }} {{ $route.params.zipcode }}
      </span>
    </transition>
    <span class="d-block:mo btn-secondary btn-sm text-semibold m-l-auto m-r-0 p-t-1:mo">
      <a  selenium="Start-Over-Link" @click="startOver">
        Start Over
      </a>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'job-request-info-heading',
  computed: {
    ...mapGetters('jobrequest', [
      'isCityChosen',
      'isStateChosen',
      'location',
      'service',
    ]),
  },
  methods: {
    startOver () {
      this.$router.push({ name: 'homepage' }, () => {
        this.$store.dispatch('jobrequest/clear');
      });
    },
  },
};
</script>
